module.exports = __webpack_public_path__ + "static/media/crow.fcd3070d.svg";